import { apiClient } from './httpClient';
import { authService } from './services/authService';
import { infoService } from './services/infoService';

export default apiClient;

export const loginApi = authService.login;
export const signUpApi = authService.signUp;
export const updateUserLanguage = authService.updateLanguage;

export const getCompanies = infoService.getCompanies;
export const getCompany = infoService.getCompany;
export const createCompany = infoService.createCompany;
export const updateCompany = infoService.updateCompany;
export const deleteCompany = infoService.deleteCompany;
export const getPriceList = infoService.getPrices;
export const createPrice = infoService.createPrice;
export const updatePrice = infoService.updatePrice;
export const deletePrice = infoService.deletePrice;